import { FC } from 'react';
import escape from 'lodash.escape';
import Head from 'next/head';

import {
  AVERAGE_RATING,
  NUMBER_OF_REVIEWS,
} from 'src/common/constants';
import { TopReview } from 'src/common/types/api/v4/boats/search';

type Review = Pick<TopReview, 'user' | 'public_review' | 'rating'>;

type ProductAggregateRatingSchemaProps = {
  sampleReviews?: Review[];
};

const ProductAggregateRatingSchema: FC<ProductAggregateRatingSchemaProps> = ({
  sampleReviews = [],
}) => (sampleReviews.length > 0 ? (
  <Head>
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Product',
          name: 'Boat Rentals',
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: AVERAGE_RATING,
            reviewCount: NUMBER_OF_REVIEWS,
            bestRating: 5,
            worstRating: 1,
          },
          review: sampleReviews.map(({
            public_review: reviewBody,
            rating,
            user,
          }) => ({
            '@type': 'Review',
            reviewRating: {
              '@type': 'Rating',
              ratingValue: rating,
            },
            author: {
              '@type': 'Person',
              name: escape(user.first_name),
            },
            reviewBody: escape(reviewBody),
          })),
        }),
      }}
    />
  </Head>
) : null);

export default ProductAggregateRatingSchema;
